import {CLEAR_LINK, GET_LINK} from "./linksActions";


const initialState = {
    name: '',
    url: '',
    author: {},
    projectId: 0,
    isLoading:true
}
const linksReducer = (state = initialState, action) => {
    switch (action.type) {
        case  GET_LINK:
            return {
                name: action.payload.name,
                url: action.payload.url,
                author: action.payload.author,
                projectId: action.payload.projectId,
                isLoading: false
            }
        case CLEAR_LINK:
            return initialState
        default:
            return initialState
    }
}


export default linksReducer